import React from 'react';
import BaseInstallmentsStep from './BaseInstallmentsStep';
import { useInstallmentsStepOne } from '../../../../../hooks/installments/useInstallmentsStepOne';

const InstallmentsStepOneCall = (context) => {
    const {
        selectedValue,
        setSelectedValue,
        amountTarget,
        setAmountTarget,
        idsPlan,
        installmentAllowed,
        handleAmountChange,
    } = useInstallmentsStepOne(context);

    return (
        <BaseInstallmentsStep
            context={context}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            amountTarget={amountTarget}
            setAmountTarget={setAmountTarget}
            idsPlan={idsPlan}
            installmentAllowed={installmentAllowed}
            handleAmountChange={handleAmountChange}
        />
    );
};

export default InstallmentsStepOneCall;
